import { SiteItem } from "@vviinn/user-managment-client-ts";
import { TextSearchNumbericTitlesKey, TextSearchParentEntity } from "./types";
import { capitalize } from "../../helpers/string/capitalize";

type TextSearchSettingsTitles = {
  [net in TextSearchNumbericTitlesKey]: string;
};

export const textCampaignWeightsKeys: Record<
  TextSearchNumbericTitlesKey,
  TextSearchParentEntity
> = {
  berryPunch1024: "imageWeights",
  volcanicWater1152: "imageWeights",
  darjeeling512: "productWeights",
};

const visualToTextNetRules = [
  ["1024", ""],
  ["1152", ""],
  ["512", "SecondFlush"],
];
export const textNets: TextSearchNumbericTitlesKey[] = [
  "berryPunch1024",
  "volcanicWater1152",
  "darjeeling512",
];

const netToNetRoot = (net: string) =>
  visualToTextNetRules.reduce(
    (accumulator, rule) => accumulator.replace(rule[0], rule[1]),
    `${net}`,
  );

export const netRootTitles = Object.fromEntries(
  textNets.map((net) => [net, netToNetRoot(net)].flat()),
) as TextSearchSettingsTitles;

const campaignToSiteNet = (net: TextSearchNumbericTitlesKey) =>
  `include${capitalize(netToNetRoot(net))}Features` as keyof SiteItem;

export const siteTextNets = textNets.map((net) => ({
  net,
  siteNet: campaignToSiteNet(net),
}));

export const textSearchSettingsTitles = Object.fromEntries(
  textNets.map((net) => [
    net,
    `${capitalize(netToNetRoot(net))
      .split(/(?=[A-Z])/)
      .join(" ")} Net`,
  ]),
) as TextSearchSettingsTitles;
